export default __webpack_public_path__ + "static/media/5050@2x.ab9ecaa4.png";